import React from "react";
import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { FaLinkedin, FaUser } from "react-icons/fa";
import { FaXTwitter, FaGoogleScholar, FaResearchgate } from "react-icons/fa6";

import "./MiniProfile.css";

export const MiniProfile = (props) => {
  /*
  const profiles = [{
    title: "Prof",
    firstName: "Dirk",
    surname: "Pesch",
    university: "University College Cork",
    bio: "https://research.ucc.ie/profiles/D005/dirk.pesch@ucc.ie",
    image: "/images/profiles/Dirk.png",
    linkedIn: "https://www.linkedin.com/in/dirk-pesch-a05b146/",
    twitter: "https://x.com/dirkpesch",
  },{
    title: "Mr",
    firstName: "James",
    surname: "Duggan",
    university: "University College Cork",
    bio: "https://advance-crt.ie/#/people/james-duggan",
    image: "/images/profiles/JamesD.png",
    linkedIn: "https://www.linkedin.com/in/james-duggan-80471b61/?originalSubdomain=ie",
    twitter: "https://x.com/advance-crt",
  },];
  */

  const [visibility, setVisibility] = useState(false);
  const [bioState, setBioState] = useState("invisible-text");
  const profile = props.props;

  function openBio() {
    if (visibility == true) {
      setBioState("invisible-text");
      setVisibility(bioState);
    } else {
      setBioState("visible-text");
      setVisibility(true);
    }
    console.log(bioState);
  }

  return (
    <div className="miniprofilepaper">
      <div className="mini-image-container">
        <img className="mini-profile-image" src={profile.image}></img>
      </div>
      <div className="mini-text-container">
        <h4 className="mini-name">
          {profile.firstName + " " + profile.surname}
        </h4>
        <p className="uni">{profile.university}</p>
        <hr></hr>
        <div className="mini-button-container">
          {profile.bio && (
            <Link to={profile.bio} className="bio-button">
              <button>
                <FaUser fontSize={"20px"} />
              </button>
            </Link>
          )}
          {profile.googlescholar && (
            <Link to={profile.googlescholar} className="bio-button">
              <button>
                <FaGoogleScholar fontSize={"20px"} />
              </button>
            </Link>
          )}
          {profile.researchgate && (
            <Link to={profile.researchgate} className="bio-button">
              <button>
                <FaResearchgate fontSize={"20px"} />
              </button>
            </Link>
          )}
          {profile.linkedin && (
            <Link to={profile.linkedIn} className="bio-button">
              <button>
                <FaLinkedin fontSize={"20px"} />
              </button>
            </Link>
          )}
          {profile.twitter && (
            <Link to={profile.twitter} className="bio-button">
              <button>
                <FaXTwitter fontSize={"20px"} />
              </button>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};
